import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { clientLandingPath } from '../utils/clientAccess';

const ProtectedRoute = ({ children, requiredPermission, requiredPermissions, requiredRole }) => {
  const { isAuthenticated, loading, hasPermission, hasAnyPermission, hasRole, user } = useAuth();
  const fallback = hasRole('client') ? clientLandingPath(user?.permissions) || '/' : '/home';

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (hasRole('client') && !requiredPermission && !requiredPermissions) {
    return <Navigate to={fallback} replace />;
  }

  if (requiredRole && !hasRole(requiredRole)) {
    return <Navigate to={fallback} replace />;
  }

  // Check for array of permissions (any one grants access)
  if (requiredPermissions && !hasAnyPermission(requiredPermissions)) {
    return <Navigate to={fallback} replace />;
  }

  // Check for single permission
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to={fallback} replace />;
  }

  return children;
};

export default ProtectedRoute;
